import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
const mainFeatures = ['6 meditaciones CIA + prácticas guiadas', 'Protocolos vibracionales para reprogramación', 'Diario digital "Yo Soy"', 'Activaciones energéticas', 'Acceso a comunidad privada'];
const sacredBonuses = [{
  title: 'Meditación Frecuencia Diamante',
  value: '$27',
  description: 'Eleva tu vibración, limpia tu energía y activa claridad espiritual.'
}, {
  title: 'Ebook "El Evangelio del Yo Soy" (30 días)',
  value: '$37',
  description: 'Afirmaciones y prácticas diarias para despertar tu poder creador.'
}];
export function SpiritualBonus() {
  return <section className="py-20 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden" data-id="element-174">
      {/* Decorative elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(249,115,22,0.05),transparent_50%)]" data-id="element-175" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(249,115,22,0.05),transparent_50%)]" data-id="element-176" />

      <div className="relative max-w-7xl mx-auto px-6" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-178">
          <div className="inline-flex items-center gap-2 bg-black text-orange-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-179">
            <Icon name="sparkles" size={18} data-id="element-180" />
            Bono Para Navidad
          </div>
          <div className="inline-block bg-gradient-to-r from-orange-400 to-orange-500 text-black px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-181">
            NUEVO
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-black mb-4 leading-tight" data-id="element-182">
            Reto de 30 Días: Recalibra tu Frecuencia y Vuelve a Dios
          </h2>
          <div className="flex items-center justify-center gap-3 text-lg" data-id="element-183">
            <span className="text-gray-500 line-through" data-id="element-184">Valor real: $297</span>
            <span className="text-2xl font-extrabold text-orange-600" data-id="element-185">
              HOY GRATIS
            </span>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-186">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-2 lg:order-1" data-id="element-187">
            <div className="relative" data-id="element-188">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-orange-600/20 blur-3xl rounded-full" data-id="element-189" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qG9JHrDqPuYCBVHpigbF5E/6871eab0a03d5873758f62e0_68040211-0990-43fd-93f4-c65d31dac930_MOCKUP-30-DYAS.png" alt="Reto de 30 Días - Reprograma tu Mente" className="relative w-full h-auto object-contain drop-shadow-2xl" data-id="element-190" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="order-1 lg:order-2" data-id="element-191">
            <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-192">
              Una experiencia espiritual guiada que combina principios
              universales, conciencia, vibración y estados elevados (F10, F12,
              F21). Diseñada para ayudarte a reconectar con Dios dentro de ti,
              soltar cargas emocionales y recuperar claridad, propósito y paz
              interna.
            </p>

            <div className="mb-8" data-id="element-193">
              <h3 className="text-xl font-bold text-black mb-4 flex items-center gap-2" data-id="element-194">
                <Icon name="gift" size={24} className="text-orange-600" data-id="element-195" />
                Lo que obtienes:
              </h3>
              <div className="space-y-3" data-id="element-196">
                {mainFeatures.map((feature, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.4 + index * 0.05
              }} className="flex items-start gap-3" data-id="element-197">
                    <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mt-0.5" data-id="element-198">
                      <Icon name="check" size={14} className="text-white" data-id="element-199" />
                    </div>
                    <p className="text-gray-800 font-medium" data-id="element-200">{feature}</p>
                  </motion.div>)}
              </div>
            </div>

            {/* Sacred Bonuses */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 border-2 border-orange-400 rounded-xl p-6" data-id="element-201">
              <h3 className="text-lg font-bold text-black mb-4 flex items-center gap-2" data-id="element-202">
                <Icon name="sparkles" size={20} className="text-orange-600" data-id="element-203" />
                Incluye 2 bonos sagrados (GRATIS):
              </h3>
              <div className="space-y-4" data-id="element-204">
                {sacredBonuses.map((bonus, index) => <motion.div key={index} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.6 + index * 0.1
              }} className="bg-white rounded-lg p-4 border border-orange-300" data-id="element-205">
                    <div className="flex items-start justify-between mb-2" data-id="element-206">
                      <h4 className="font-bold text-black flex-1" data-id="element-207">
                        BONO #{index + 1} — {bonus.title}
                      </h4>
                      <span className="text-sm font-bold text-orange-600 whitespace-nowrap ml-2" data-id="element-208">
                        Valor: {bonus.value}
                      </span>
                    </div>
                    <p className="text-sm text-gray-700" data-id="element-209">{bonus.description}</p>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}